export const ALLOW_SCOPES_SHARED = "allowScopesShared";
export const OAUTH_AUTHORIZE_SHARED = "oauthAuthorizeShared";
